<template>
    <div
        class="modal fade"
        id="editParticipationTypeModal"
        role="dialog"
        aria-labelledby="participationTypeUpdateModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5
                        class="modal-title"
                        id="participationTypeUpdateModalLabel"
                    >{{$t('participationType.edit')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ParticipationTypeEditCard
                        v-model="model"
                        v-if="showEditor"
                        :create="false"
                        @save="onSave"
                        @cancel="onCancel"
                    ></ParticipationTypeEditCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ParticipationType } from "../../../models/models";
import ParticipationTypeEditCard from "./ParticipationTypeEditCard";

export default {
    components: {
        ParticipationTypeEditCard,
    },
    props: {
        value: {
            type: Object,
            required: false,
        },
        show: {
            type: Boolean,
            default: false,
        },
        profileManagement: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showEditor: false,
            model: new ParticipationType(),
        };
    },
    methods: {
        onClose() {
            this.$emit("onClose", { ...this.model });
            this.model = new ParticipationType();
            this.$validator.reset();
        },
        hide() {
            $(this.$el).modal("hide");
        },
        onSave(model) {
            this.$emit("onSave", model);
            this.onClose();
        },
        onCancel() {
            this.onClose();
        },
    },
    mounted() {
        // add modal close listener
        $(this.$el).on("hidden.bs.modal", this.onClose);
    },
    beforeDestroy() {
        // remove listener
        $(this.$el).off("hidden.bs.modal");
    },
    watch: {
        show: function (val) {
            if (val) {
                this.model = new ParticipationType(this.value);
                this.showEditor = true;
                $(this.$el).modal("show");
            } else {
                $(this.$el).modal("hide");
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.bmd-form-group {
    padding-top: 0px !important;
}
</style>
